const logoCarousel = () => {
    const carousels = document.querySelectorAll("[data-slider='logos']");

    if (!carousels.length) return;

    carousels.forEach(track => {
        const wrapper = track.parentElement;
        const originalSlides = Array.from(track.children);

        if (!originalSlides.length) return;

        let columnGap = getColumnGap();

        function getColumnGap() {
            const style = window.getComputedStyle(track);
            return parseFloat(style.columnGap) || 0;
        }

        function measureSetWidth(slides) {
            let total = 0;

            slides.forEach((slide, index) => {
                total += slide.offsetWidth;
                if (index !== slides.length - 1) {
                    total += columnGap;
                }
            });

            return total;
        }

        function setupSlides() {
            track.innerHTML = "";
            originalSlides.forEach(slide => track.appendChild(slide.cloneNode(true)));
            const baseSet = Array.from(track.children);
            const baseSetWidth = measureSetWidth(baseSet);

            for (let i = 0; i < 2; i++) {
                originalSlides.forEach(slide =>
                    track.appendChild(slide.cloneNode(true))
                );
            }

            return { baseSetWidth };
        }

        let { baseSetWidth: originalSetWidth } = setupSlides();
        let pos = 0;
        let speed = getSpeed();

        function getSpeed() {
            return window.innerWidth <= 768 ? 0.8 : 1.3;
        }

        let paused = false;

        wrapper.addEventListener("mouseenter", () => {
            if (!isDragging) {
                wrapper.style.cursor = "grab";
            }
            paused = true;
        });

        wrapper.addEventListener("mouseleave", () => {
            if (!isDragging) {
                wrapper.style.cursor = "default";
            }
            paused = false;
        });

        let isDragging = false;
        let dragStartX = 0;
        let dragLastX = 0;

        function onDragStart(clientX) {
            paused = true;
            isDragging = true;
            dragStartX = clientX;
            dragLastX = clientX;
            wrapper.style.cursor = "grabbing";
        }

        function onDragMove(clientX) {
            if (!isDragging) return;
            const deltaX = clientX - dragLastX;

            pos += deltaX;
            dragLastX = clientX;

            if (pos > 0) {
                pos -= originalSetWidth + columnGap;
            } else if (pos <= -(originalSetWidth + columnGap)) {
                pos += originalSetWidth + columnGap;
            }

            track.style.transform = `translateX(${pos}px)`;
        }

        function onDragEnd() {
            isDragging = false;
            paused = false;
            wrapper.style.cursor = "grab";
        }

        wrapper.addEventListener("mousedown", e => {
            e.preventDefault();
            onDragStart(e.clientX);
        });

        wrapper.addEventListener("touchstart", e => {
            if (e.touches.length === 1) {
                onDragStart(e.touches[0].clientX);
            }
        });

        window.addEventListener("mousemove", e => {
            if (isDragging) {
                e.preventDefault();
                onDragMove(e.clientX);
            }
        });

        window.addEventListener(
            "touchmove",
            e => {
                if (isDragging && e.touches.length === 1) {
                    onDragMove(e.touches[0].clientX);
                }
            },
            { passive: false }
        );

        window.addEventListener("mouseup", () => {
            if (isDragging) onDragEnd();
        });

        window.addEventListener("touchend", () => {
            if (isDragging) onDragEnd();
        });

        function animate() {
            if (!paused && !isDragging) {
                pos -= speed;
                if (pos <= -(originalSetWidth + columnGap)) {
                    pos += originalSetWidth + columnGap;
                }

                track.style.transform = `translateX(${pos}px)`;
            }

            requestAnimationFrame(animate);
        }

        animate();

        window.addEventListener("resize", () => {
            speed = getSpeed();

            columnGap = getColumnGap();
            track.style.transition = "none";
            pos = 0;
            track.style.transform = `translateX(${pos}px)`;
            const setup = setupSlides();

            originalSetWidth = setup.baseSetWidth;
            paused = false;
        });
    });
};

document.addEventListener('DOMContentLoaded', logoCarousel);
